/* @flow */

import Honeybadger from 'honeybadger-js';
import { retrieve } from 'putki';

const environment = window.__ENVIRONMENT__;

Honeybadger.configure({
  api_key: '087b96bb',
  environment: environment,
  disabled: environment !== 'staging' && environment !== 'production',
  onerror: false
});

Honeybadger.beforeNotify(notice => {
  if (suppressCurrentUserAgent()) {
    return false;
  }

  notice.component = retrieve('controller');
  notice.action = retrieve('action');
  console.warn('[Honeybadger]', notice); // eslint-disable-line no-console

  return true;
});

function suppressCurrentUserAgent() {
  if (!window.navigator) return false;
  return window.navigator.userAgent.includes('BingPreview');
}
